import { render, staticRenderFns } from "./bussinessHours.vue?vue&type=template&id=047e716f&scoped=true&"
import script from "./bussinessHours.vue?vue&type=script&lang=js&"
export * from "./bussinessHours.vue?vue&type=script&lang=js&"
import style0 from "./bussinessHours.vue?vue&type=style&index=0&id=047e716f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047e716f",
  null
  
)

export default component.exports
import {QPage,QBtn,QMenu,QList,QItem,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBtn,QMenu,QList,QItem})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
